export class StockItemFilter {
  stockId: number | null = null
  stockIds: number[] = []
  query: string | null = null
}
